export enum MerchantIPNKind {
  Replenish = 'Replenish',
  Withdraw = 'Withdraw',
  Invoice = 'Invoice',
  WithdrawBatch = 'WithdrawBatch',
  CryptoExchangeWithdraw = 'CryptoExchangeWithdraw',
  FiatExchangeWithdraw = 'FiatExchangeWithdraw',
  Exchange = 'Exchange',
  CryptoInvoice = 'CryptoInvoice'
}
